// extracted by mini-css-extract-plugin
export default {"page":"email-templates_page__oAHgP","container":"email-templates_container__ZzOLv"};